// extracted by mini-css-extract-plugin
module.exports = {"main__container":"style_main__container__2aREf","accordion__container":"style_accordion__container__1FP5r","accordion__title":"style_accordion__title__2vsSk"};